export default (maxClickpathCount = 100) => {
	let clickPath = JSON.parse(
		sessionStorage.getItem('ws-tracking-clickpath') || '[]'
	);
	if (clickPath.length > maxClickpathCount) {
		clickPath = clickPath.slice(
			clickPath.length - maxClickpathCount,
			clickPath.length
		);
	}

	const clickPathValue = clickPath
		.map((click) => {
			const { viewType, timestamp, path } = click;
			return `${timestamp}|${viewType}|${path}`;
		})
		.join('^');

	const $clickPathInput = document.createElement('input');
	$clickPathInput.type = 'hidden';
	$clickPathInput.name = 'clickpath';
	$clickPathInput.value = clickPathValue;

	window.DDC.dataLayer.events.listener.listen(
		'ddc.form.submission',
		({ element }) => {
			if (element && element.closest('form')) {
				element.closest('form').appendChild($clickPathInput);
			}
		}
	);
};
